import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../../dtos/selector";

const getInversionistasService = async () => {
    const response: Promise<AxiosResponse<ListResponseDto<selectorTransversal>>> = axiosInstance.get(`siscred-api-transversal/v1/instituciones/obtener-datos-inversionista`);
    return response;
}

export {getInversionistasService}